import type { ComponentType } from 'react'
import { Code, FileText, Image as ImageIcon } from 'lucide-react'
import { ArchiveIcon } from '@/components/icons'
import { CONNECTOR_LABELS } from '@/components/projects/connectors/connectorConstants'
import { CONNECTOR_ICONS } from '@/components/projects/connectors/connectorIcons'
import type { ConnectorType } from '@/types'

type IconComponent = ComponentType<{ className?: string, 'aria-hidden'?: boolean | 'true' | 'false' }>

const IMAGE_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp', 'svg']
const SOURCE_CODE_EXTENSIONS = ['ts', 'tsx', 'js', 'jsx', 'cs', 'py', 'java', 'go', 'rb', 'php', 'cpp', 'rs']

export function getFileIconComponent(filename: string): IconComponent {
  const ext = filename.split('.').pop()?.toLowerCase() ?? ''
  if (IMAGE_EXTENSIONS.includes(ext)) return ImageIcon
  if (SOURCE_CODE_EXTENSIONS.includes(ext)) return Code
  if (ext === 'zip') return ArchiveIcon
  return FileText
}

export function isMarkdownContextFile(filename: string): boolean {
  return (filename.split('.').pop()?.toLowerCase() ?? '') === 'md'
}

export interface SourceCodeIcon {
  Icon: IconComponent
  label: string
  isFallback: boolean
}

export function getSourceCodeIcon(connectorType: string | null): SourceCodeIcon {
  if (connectorType != null && connectorType in CONNECTOR_ICONS) {
    const type = connectorType as ConnectorType
    return { Icon: CONNECTOR_ICONS[type] as IconComponent, label: CONNECTOR_LABELS[type], isFallback: false }
  }
  return { Icon: Code, label: 'Source code', isFallback: true }
}
